import { FC } from 'react';
import { UUID } from 'crypto';
import { Menu, Text, Anchor, Flex } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';
import { AppPaths } from '@/configs/appPaths';
import { SlArrowDown } from 'react-icons/sl';
import ProductTypeApi from '@/remoteApi/ProductTypeApi';
import classNames from 'classnames';
import Link from 'next/link';

interface Props {
	currentProductType: UUID;
}

export const ProductTypesMenu: FC<Props> = (props) => {
	const productTypesQuery = useQuery({
		queryKey: [
			ProductTypeApi.queryKey,
			{},
			{
				'filter.isHidden': false,
			},
		],
		queryFn: ProductTypeApi.getAll,
	});

	return (
		<Menu shadow="md" width={200}>
			<Menu.Target>
				<Anchor
					className={classNames({
						'link-disabled': !productTypesQuery.data,
					})}
				>
					<Flex gap="xs">
						<Text fw="bold" c="black">
							Zmień produkt
						</Text>
						<SlArrowDown size={12} color="black" />
					</Flex>
				</Anchor>
			</Menu.Target>

			<Menu.Dropdown>
				{productTypesQuery.data?.map((productType) => (
					<Menu.Item
						key={productType.id}
						disabled={productType.id === props.currentProductType}
						component={Link}
						href={`/${AppPaths.PRODUCT_TYPES}/${productType.id}/form`}
					>
						<Text>{productType.name}</Text>
					</Menu.Item>
				))}
			</Menu.Dropdown>
		</Menu>
	);
};
